import { Vehicle } from '@deliveries-app/models';

export enum VehicleActionTypes {
  VEHICLE_REQUEST = 'vehicles/VEHICLE_REQUEST',
  GET_ALL_VEHICLES_SUCCESS = 'vehicles/GET_ALL_VEHICLES_SUCCESS',
  GET_ALL_VEHICLES_FAILURE = 'vehicles/GET_ALL_VEHICLES_FAILURE',
}

export type VehicleActions =
  | { type: VehicleActionTypes.VEHICLE_REQUEST }
  | { type: VehicleActionTypes.GET_ALL_VEHICLES_SUCCESS; payload: Vehicle[] }
  | { type: VehicleActionTypes.GET_ALL_VEHICLES_FAILURE; payload: string };
